import React from 'react';
import DashboardSidebar from '../components/DashboardSidebar';
import TherapistCommunityPostManager from '../components/TherapistCommunityPostManager';
import { getAuthSession } from '../services/api';

function TherapistCommunityPage() {
  const authSession = getAuthSession();
  const user = authSession?.user;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <DashboardSidebar userRole="physiotherapist" />
      <div className="sidebar-content-wrapper" style={{ flex: 1, padding: '32px 40px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: 800, color: '#1e293b', margin: '0 0 8px 0' }}>
            💬 Community Posts & Clinical Insights
          </h1>
          <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>
            Welcome, Dr. {user?.name || 'Practitioner'}. Share your clinical insights, psychoeducation tips, and interact with the MentalHealth community.
          </p>
        </div>

        <TherapistCommunityPostManager />
      </div>
    </div>
  );
}

export default TherapistCommunityPage;
